import { render, staticRenderFns } from "./HistoricalChart.vue?vue&type=template&id=6238086a&"
import script from "./HistoricalChart.vue?vue&type=script&lang=js&"
export * from "./HistoricalChart.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports